import React, { FC } from 'react'
import { ChevronLeft, ChevronRight } from 'components/icons'
import { ButtonGroupProps, CarouselInternalState } from 'react-multi-carousel/lib/types'
import cn from 'classnames'
import s from './carousel.module.css'

const Arrows: FC<ButtonGroupProps> = ({ next, previous, carouselState }) => {
  const { currentSlide, totalItems, slidesToShow } = carouselState as CarouselInternalState
  const max = totalItems - slidesToShow

  return (
    <div className={s.arrowsContainer}>
      {currentSlide >= 1 && (
        <button type="button" className={cn(s.button, s.left)} onClick={previous}>
          <span>
            <ChevronLeft />
          </span>
        </button>
      )}

      {currentSlide < max && (
        <button type="button" className={cn(s.button, s.right)} onClick={next}>
          <span>
            <ChevronRight />
          </span>
        </button>
      )}
    </div>
  )
}

export { Arrows }
